import {
    // BONDS_DEFAULTEDS_PATH,
    // BONDS_GUARANTORS_PATH,
    // BONDS_CADASTRO_BONDS_ACI_PATH,
    // BONDS_CADASTRO_BONDS_PATH,
    // BONDS_NEWFLOW_PATH,
    // BONDS_OFFER_PATH,
    // BONDS_TRADINGS_PATH,
    // DATALAKE_ALIAS_NOMES_DEVEDORES_PATH,
    // DATALAKE_AMORT_DEPREC_CVM_PATH,
    // DATALAKE_AMORT_DEPREC_DFC_AUX_CVM_PATH,
    // DATALAKE_AMORT_DEPREC_DRE_AUX_CVM_PATH,
    // DATALAKE_ATUALIZACAO_INDICES_PATH,
    // DATALAKE_B3_ATIVOS_REG_PATH,
    // DATALAKE_B3_NEG_ANALITICO_PATH,
    // DATALAKE_B3_NEG_CONSOLIDADO_PATH,
    // DATALAKE_B3_SETORES_PATH,
    // DATALAKE_B3_TICKER_CNPJ_PATH,
    // DATALAKE_BACEN_CADASTRO_CONGLOMERADO_PATH,
    // DATALAKE_BACEN_CADASTRO_EMPRESA_PATH,
    // DATALAKE_BACEN_SEGMENTACAO_PATH,
    // DATALAKE_BROADCAST_COTACOES_ACOES_B3_PATH,
    // DATALAKE_CALENDARIO_INFLACAO,
    // DATALAKE_CHECAGEM_DADOS_FINANCEIROS_CVM_PATH,
    // DATALAKE_CONTRAPARTE_PATH,
    // DATALAKE_CURVAS_SPREADS_INDICATIVOS_PATH,
    // DATALAKE_CVM_BPA_PATH,
    // DATALAKE_CVM_BPATRAT_PATH,
    // DATALAKE_CVM_BPP_PATH,
    // DATALAKE_CVM_BPPTRAT_PATH,
    // DATALAKE_CVM_COMPOSICAO_CAPITAL_PATH,
    // DATALAKE_CVM_CADASTRO_EMISSOR_PATH,
    // DATALAKE_CVM_CADASTRO_EMPRESAS_PATH,
    // DATALAKE_CVM_CADASTRO_SITUACAO_PATH,
    // DATALAKE_CVM_DFC_PATH,
    // DATALAKE_CVM_DFCTRAT_PATH,
    // DATALAKE_CVM_DMLP_PATH,
    // DATALAKE_CVM_DMLPTRAT_PATH,
    // DATALAKE_CVM_DRA_PATH,
    // DATALAKE_CVM_DRE_PATH,
    // DATALAKE_CVM_DRETRAT_PATH,
    // DATALAKE_CVM_DVAT_PATH,
    // DATALAKE_CVM_FATOS_RELEVANTES_PATH,
    // DATALAKE_CVM_PARECERES_PATH,
    // DATALAKE_CVM_DADOS_FINANCEIROS_PATH,
    // DATALAKE_EMISSAO_CARACTERISTICAS_PATH,
    // DATALAKE_EMISSAO_LTV_PATH,
    // DATALAKE_ESTRUTURA_DFS_EMPRESA_CVM_PATH,
    // DATALAKE_EVENTOS_CREDITO_DEVEDOR_PATH,
    // DATALAKE_EVENTOS_CREDITO_EMISSAO_PATH,
    // DATALAKE_FINCS_EVENTOS_PATH,
    // DATALAKE_FINCS_JUROS_PATH,
    // DATALAKE_FINCS_MARKET_DATA_PATH,
    // DATALAKE_INDICE_INFLACAO_PATH,
    // DATALAKE_LIQUIDEZ_PATH,
    // DATALAKE_LISTA_PALAVRAS_EBITDA_CVM_PATH,
    // DATALAKE_LISTA_PALAVRAS_TRIBUTOS_CVM_PATH,
    // DATALAKE_MAPPING_CONTAS_CVM_PATH,
    // DATALAKE_PERIODICIDADE_BALANCO_PATH,
    // DATALAKE_PRECOS_ANDADOS_PATH,
    // DATALAKE_PRECOS_EVENTOS_FINANCEIROS_PUMTM_PATH,
    // DATALAKE_PRECOS_EVENTOS_FINANCEIROS_PUPAR_PATH,
    // DATALAKE_PRECOS_INADIMPLENTES_LGD_PATH,
    // DATALAKE_PRECOS_PROCESSADOS_BONDS_PATH,
    // DATALAKE_PRECOS_PROCESSADOS_PATH,
    // DATALAKE_PRECOS_SPREADS_INDICATIVOS_PATH,
    // DATALAKE_PRECOS_SREADS_RELATIVOS_PATH,
    // DATALAKE_PRECOS_TUNEL_PATH,
    // DATALAKE_PREVIA_INFLACAO_PATH,
    // DATALAKE_RATING_DEVEDOR_PATH,
    // DATALAKE_RATING_EMISSAO_PATH,
    // DATALAKE_RELATORIO_INCONSISTENCIA_DADOS_FINANCEIROS_CVM_PATH,
    // DATALAKE_RISK_FREE,
    // DATALAKE_SELECAO_CONTAS_EBITDA_CVM_PATH,
    // DATALAKE_SELECAO_CONTAS_TRIBUTOS_CVM_PATH,
    // DATALAKE_SETORIAL_PERSPECTIVA_PATH,
    // DATALAKE_SPREADS_DEVEDOR_PATH,
    // DATALAKE_SPREADS_EMISSAO,
    // DATALAKE_SPREADS_IF_NEG,
    // DATALAKE_SPREADS_INDICATIVOS_BRUTO_PATH,
    // DATALAKE_SPREADS_LIQUIDEZ_PATH,
    // DATALAKE_SPREADS_NEGOCIADOS_PATH,
    // DATALAKE_SPREADS_SEC_PULVERIZADO_PATH,
    // DATALAKE_TAXAS_JUROS,
    // DATALAKE_TAXAS_TR_PATH,
    // DATALAKE_TIPO_ESTRUTURAS_DFS_CVM_PATH,
    // DATALAKE_TRIBUTOS_CVM_PATH,
    // RATER_MM_COTACOES_ACOES_B3_AJUSTADO_PATH,
    // RATER_MM_COTACOES_PATH,
    // RATER_MM_PD_PATH,
    // RATER_MM_RESULTADO_EMPRESA_PATH,
    // RATER_MM_RESULTADO_RATING_PATH,
    // RATER_MM_TICKER_CNPJ_PATH,
    // RATER_MM_VOLATILIDADE_TICKER_PATH,
    // RATER_USER_CADASTRO_EMPRESA_PATH,
    // RATER_USER_SETORIAL_PATH,
    DATALAKE_CONSULTA_DADOS_PATH
} from "src/utils/api-routes"
import {DATALAKE, CBONDS, RATER, MOTOR} from "src/utils/constants"
import ParameterCBondsBondsDefaultedsTable from "./tables/parameter-cbonds-bonds-defaulteds-table"
import ParameterCBondsBondsGuarantorsTable from "./tables/parameter-cbonds-bonds-guarantors-table"
import ParameterCBondsCadastroBondsAciTable from "./tables/parameter-cbonds-cadastro-bonds-aci-table"
import ParameterCBondsCadastroBondsTable from "./tables/parameter-cbonds-cadastro-bonds-table"
import ParameterCBondsNewFlowTable from "./tables/parameter-cbonds-new-flow-table"
import ParameterCBondsOfferTable from "./tables/parameter-cbonds-offer-table"
import ParameterCBondsTradingsTable from "./tables/parameter-cbonds-tradings-table"
import ParameterAliasNomeDevedorTable from "./tables/parameter-datalake-alias-nome-devedor-table"
import ParameterAmortDeprecCVMTable from "./tables/parameter-datalake-amort-deprec-cvm-table"
import ParameterAmortDeprecDFCAuxCVMTable from "./tables/parameter-datalake-amort-deprec-dfc-aux-cvm-table"
import ParameterAmortDeprecDREAuxCVMTable from "./tables/parameter-datalake-amort-deprec-dre-aux-cvm-table"
import ParameterDatalakeANBIMANegociosTPFTable from "./tables/parameter-datalake-anbima-negocios-tpf-table"
import ParameterANBIMAPrecosTable from "./tables/parameter-datalake-anbima-precos-table"
import ParameterDatalakeANBIMAPrecosTPFTable from "./tables/parameter-datalake-anbima-precos-tpf-table"
import ParameterDatalakeAtualizacaoIndicesTable from "./tables/parameter-datalake-atualizacao-indices"
import ParameterB3AtivosRegTable from "./tables/parameter-datalake-b3-ativos-reg-table"
import ParameterDatalakeB3FundosNETTable from "./tables/parameter-datalake-b3-fundos-net-table"
import ParameterDatalakeB3ISINEmissorTable from "./tables/parameter-datalake-b3-isin-emissor-table"
import ParameterDatalakeB3ISINRelacaoTable from "./tables/parameter-datalake-b3-isin-relacao-table"
import ParameterB3NegAnaliticoTable from "./tables/parameter-datalake-b3-neg-analitico-table"
import ParameterB3NegConsolidadoTable from "./tables/parameter-datalake-b3-neg-consolidado-table"
import ParameterB3SetoresTable from "./tables/parameter-datalake-b3-setores"
import ParameterB3TickerCNPJTable from "./tables/parameter-datalake-b3-ticker-cnpj"
import ParameterDatalakeBACENCadastroConglomeradoTable
    from "./tables/parameter-datalake-bacen-cadastro-conglomerado-table"
import ParameterDatalakeBACENCadastroEmpresaTable from "./tables/parameter-datalake-bacen-cadastro-empresa-table"
import ParameterDatalakeBACENSegmentacaoTable from "./tables/parameter-datalake-bacen-segmentacao-table"
import ParameterDatalakeB3AcoesNegAnaliticoTable from "./tables/parameter-datalake-b3-acoes-neg-analitico-table"
import ParameterDatalakeB3AcoesRegistradoTable from "./tables/parameter-datalake-b3-acoes-registrados-table"
import ParameterBroadcastCotacoesAcoesB3Table from "./tables/parameter-datalake-broadcast-cotacoes-acoes-b3-table"
import ParameterCalendarioInflacaoTable from "./tables/parameter-datalake-calendario-inflacao-table"
import ParameterDatalakeCETIPOperacoesTable from "./tables/parameter-datalake-cetip-operacoes-table"
import ParameterCaracteristicasEmissaoTable from "./tables/parameter-datalake-emissao-caracteristicas"
import ParameterChecagemDadosFinanceirosCVMTable from "./tables/parameter-datalake-checagem-dados-financeiros-cvm-table"
import ParameterContraparteTable from "./tables/parameter-datalake-contraparte-table"
import ParameterCurvasSpreadsIndicativosTable from "./tables/parameter-datalake-curvas-spreads-indicativos-table"
import ParameterCVMCadastroEmissorTable from "./tables/parameter-datalake-cvm-cadastro-emissor-table"
import ParameterCVMCadastroEmpresasTable from "./tables/parameter-datalake-cvm-cadastro-empresas-table"
import ParameterCVMCadastroSituacaoTable from "./tables/parameter-datalake-cvm-cadastro-situacao-table"
import ParameterCVMComposicaoCapitalTable from "./tables/parameter-datalake-cvm-composicao-capital-table"
import ParameterCVMDadosFinanceirosTable from "./tables/parameter-datalake-cvm-dados-financeiros-table"
import ParameterCVMFatosRelevantesTable from "./tables/parameter-datalake-cvm-fatos-relevantes-table"
import ParameterCVMPareceresTable from "./tables/parameter-datalake-cvm-pareceres-table"
import ParameterCVMBPATable from "./tables/parameter-datalake-cvmbpa-table"
import ParameterCVMBPATRATTable from "./tables/parameter-datalake-cvmbpatrat-table"
import ParameterCVMBPPTable from "./tables/parameter-datalake-cvmbpp-table"
import ParameterCVMBPPTRATTable from "./tables/parameter-datalake-cvmbpptrat-table"
import ParameterCVMDFCTable from "./tables/parameter-datalake-cvmdfc-table"
import ParameterCVMDFCTRATTable from "./tables/parameter-datalake-cvmdfctrat-table"
import ParameterCVMDMPLTable from "./tables/parameter-datalake-cvmdmpl-table"
import ParameterCVMDMPLTRATTable from "./tables/parameter-datalake-cvmdmpltrat-table"
import ParameterCVMDRATable from "./tables/parameter-datalake-cvmdra-table"
import ParameterCVMDRETable from "./tables/parameter-datalake-cvmdre-table"
import ParameterCVMDRETRATTable from "./tables/parameter-datalake-cvmdretrat-table"
import ParameterCVMDVATable from "./tables/parameter-datalake-cvmdva-table"
import ParameterEstruturaDFsEmpresaCVMTable from "./tables/parameter-datalake-estrutura-dfs-empresa-cvm-table"
import ParameterPrecosVariacaoDiariaTable from "./tables/parameter-datalake-precos-variacao-diaria"
import ParameterEventosCreditoDevedorTable from "./tables/parameter-datalake-eventos-credito-devedor"
import ParameterEventosCreditoEmissaoTable from "./tables/parameter-datalake-eventos-credito-emissao"
import ParameterFincsEventosTable from "./tables/parameter-datalake-fincs-eventos-table"
import ParameterFincsJurosTable from "./tables/parameter-datalake-fincs-juros-table"
import ParameterFincsMarketDataTable from "./tables/parameter-datalake-fincs-marketdata-table"
import ParameterIndiceInflacaoTable from "./tables/parameter-datalake-indice-inflacao-table"
import ParameterLiquidezTable from "./tables/parameter-datalake-liquidez-table"
import ParameterListaPalavrasEBITDACVMTable from "./tables/parameter-datalake-lista-palavras-ebitda-cvm-table"
import ParameterListaPalavrasTributosCVMTable from "./tables/parameter-datalake-lista-palavras-tributos-cvm-table"
import ParameterLTVEmissaoTable from "./tables/parameter-datalake-emissao-ltv"
import ParameterMappingContasCVMTable from "./tables/parameter-datalake-mapping-contas-cvm-table"
import ParameterPeriodicidadeBalancoTable from "./tables/parameter-datalake-periodicidade-balanco-table"
import ParameterPrecosAndadosTable from "./tables/parameter-datalake-precos-andados-table"
import ParameterPrecosEventosFinanceirosPUMTMTable
    from "./tables/parameter-datalake-precos-eventos-financeiros-pumtm-table"
import ParameterPrecosEventosFinanceirosPUPARTable
    from "./tables/parameter-datalake-precos-eventos-financeiros-pupar-table"
import ParameterPrecosInadimplentesLGDTable from "./tables/parameter-datalake-precos-inadimplentes-lgd-table"
import ParameterPrecosProcessadosBondsTable from "./tables/parameter-datalake-precos-processados-bonds-table"
import ParameterPrecosProcessadosTable from "./tables/parameter-datalake-precos-processados-table"
import ParameterPrecosSpreadsIndicativosTable from "./tables/parameter-datalake-precos-spreads-indicativos-table"
import ParameterPrecosSpreadsRelativosTable from "./tables/parameter-datalake-precos-spreads-relativos-table"
import ParameterPrecosTunelTable from "./tables/parameter-datalake-precos-tunel-table"
import ParameterPrecosValidacaoPUPARTable from "./tables/parameter-datalake-precos-validacao-pupar-table"
import ParameterPreviaInflacaoTable from "./tables/parameter-datalake-previa-inflacao"
import ParameterRatingDevedorTable from "./tables/parameter-datalake-rating-devedor-table"
import ParameterRatingEmissaoTable from "./tables/parameter-datalake-rating-emissao-table"
import ParameterRelatorioInconsistenciaDadosFinanceirosCVMTable
    from "./tables/parameter-datalake-relatorio-inconsistencia-dados-financeiros-cvm-table"
import ParameterRiskFreeTable from "./tables/parameter-datalake-risk-free-table"
import ParameterDatalakeSecuritizacoesInformeMensalTable from "./tables/parameter-datalake-securitizacoes-informe-mensal-table"
import ParameterSelecaoContasEBITDACVMTable from "./tables/parameter-datalake-selecao-contas-ebitda-cvm-table"
import ParameterSelecaoContasTributosCVMTable from "./tables/parameter-datalake-selecao-contas-tributos-cvm-table"
import ParameterSetorialPerspectivaTable from "./tables/parameter-datalake-setorial-perspectiva"
import ParameterSpreadsDevedorTable from "./tables/parameter-datalake-spreads-devedor"
import ParameterSpreadsEmissaoTable from "./tables/parameter-datalake-spreads-emissao-table"
import ParameterSpreadsIfNegTable from "./tables/parameter-datalake-spreads-if-neg-table"
import ParameterSpreadsIndicativosBrutoTable from "./tables/parameter-datalake-spreads-indicativos-bruto"
import ParameterSpreadsLiquidezTable from "./tables/parameter-datalake-spreads-liquidez"
import ParameterSpreadsNegociadosTable from "./tables/parameter-datalake-spreads-negociados"
import ParameterSpreadsSecPulverizadoTable from "./tables/parameter-datalake-spreads-sec-pulverizado"
import ParameterTaxaJurosTable from "./tables/parameter-datalake-taxa-juros-table"
import ParameterTaxasTrTable from "./tables/parameter-datalake-taxas-tr-table"
import ParameterTipoEstruturasDFsCVMTable from "./tables/parameter-datalake-tipo-estruturas-dfs-cvm-table"
import ParameterTributosCVMTable from "./tables/parameter-datalake-tributos-cvm-table"
import ParameterEmissaoRendaFixaParametrosTable from "./tables/parameter-motor-emissao-renda-fixa-parametros-table"
import ParameterEmissaoRendaFixaEventosOrdinariosTable from "./tables/parameter-motor-emissao-renda-fixa-eventos-ordinarios-table"
import ParameterEmissaoRendaFixaCadastroControleTable from "./tables/parameter-motor-emissao-renda-fixa-cadastro-controle-table"
import ParameterEmissaoRendaFixaCaracteristicasTable from "./tables/parameter-motor-emissao-renda-fixa-caracteristicas-table"
import ParameterEmissaoRendaFixaCovenantsTable from "./tables/parameter-motor-emissao-renda-fixa-covenants-table"
import ParameterEmissaoRendaFixaGarantiasTable from "./tables/parameter-motor-emissao-renda-fixa-garantias-table"
import ParameterEmissaoRendaFixaLTVTable from "./tables/parameter-motor-emissao-renda-fixa-ltv-table"
import ParameterEmissaoRendaFixaOfertaTable from "./tables/parameter-motor-emissao-renda-fixa-oferta-table"
import ParameterEmissaoRendaFixaDataAniversarioTable from "./tables/parameter-motor-emissao-renda-fixa-data-aniversario-table"
import ParameterEmissaoRendaFixaEventosExtraordinariosTable from "./tables/parameter-motor-emissao-renda-fixa-eventos-extraordinarios-table"
import ParameterEmissaoRendaFixaPremioTable from "./tables/parameter-motor-emissao-renda-fixa-premio-table"
import ParameterEmissaoRendaFixaEventosConciliacaoTable from "./tables/parameter-motor-emissao-renda-fixa-eventos-conciliacao-table"
import ParameterEmissaoRendaFixaRecompraProgramadaTable from "./tables/parameter-motor-emissao-renda-fixa-recompra-programada-table"
import ParameterEmissaoRendaFixaConversibilidadeTable from "./tables/parameter-motor-emissao-renda-fixa-conversibilidade-table"
import ParameterPrecosCalculadosConversibilidadeTable from "./tables/parameter-motor-precos-calculados-conversibilidade-table"
import ParameterFormulaPremioTable from "./tables/parameter-motor-formula-premio-table"
import ParameterJurosTable from "./tables/parameter-motor-juros-table"
import ParameterControleLogEmissaoRendaFixaTable from "./tables/parameter-motor-controle-log-emissao-renda-fixa" 
import ParameterPrecosValidacaoDiarioTable from "./tables/parameter-motor-precos-validacao-diario-table"   
import ParameterRaterMMCotacoesAcoesB3AjustadoTable from "./tables/parameter-rater-mm-cotacoes-ajustadas"
import ParameterRaterMMCotacoesTable from "./tables/parameter-rater-mm-cotacoes"
import ParameterRaterMMPDTable from "src/pages/rater/subpages/tables/parameter-rater-mm-pd"
import ParameterRaterMMResultadoEmpresaTable from "./tables/parameter-rater-mm-resultado-empresa"
import ParameterRaterMMResultadoRatingTable from "./tables/parameter-rater-mm-resultado-rating"
import ParameterRaterMMTickerCNPJTable from "./tables/parameter-rater-mm-ticker-cnpj"
import ParameterRaterMMVolatilidadeTickerTable from "./tables/parameter-rater-mm-volatilidade-ticker"
import ParameterRaterUserCadastroEmpresasTable from "./tables/parameter-rater-user-cadastro-empresas"
import ParameterRaterUserSetorialTable from "./tables/parameter-rater-user-setorial"
import ParameterPrecosEventosFinanceirosTable from "./tables/parameter-motor-precos-eventos-financeiros"
import ParameterPrecosCalculadosTable from "./tables/parameter-motor-precos-calculados"
import ParameterPrecosCalculadosAberturaTable from "./tables/parameter-motor-precos-calculados-abertura"
import ParameterMemoriaCalculoPUPARTable from "./tables/parameter-motor-memoria-calculo-pupar"
import ParameterMemoriaCalculoPUMTMTable from "./tables/parameter-motor-memoria-calculo-pumtm"
import ParameterMemoriaCalculoFatorCorrecaoTable from "./tables/parameter-motor-memoria-calculo-fator-correcao"
import ParameterMemoriaCalculoPUAberturaTable from "./tables/parameter-motor-memoria-calculo-pu-abertura"

export const parameterDatalakeTableList = [
    {
        key: "CBonds_Defaulteds",
        label: "CBonds_Defaulteds",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCBondsBondsDefaultedsTable,
        app: CBONDS,
        model: "CBonds_BondsDefaulteds",
    },
    {
        key: "CBonds_Guarantors",
        label: "CBonds_Guarantors",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCBondsBondsGuarantorsTable,
        app: CBONDS,
        model: "CBonds_BondsGuarantors",
    },
    {
        key: "CBonds_CadastroBondsAci",
        label: "CBonds_CadastroBondsAci",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCBondsCadastroBondsAciTable,
        app: CBONDS,
        model: "CBonds_CadastroBondsAci",
    },
    {
        key: "CBonds_CadastroBonds",
        label: "CBonds_CadastroBonds",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCBondsCadastroBondsTable,
        app: CBONDS,
        model: "CBonds_CadastroBonds",
    },
    {
        key: "CBonds_Newflow",
        label: "CBonds_Newflow",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCBondsNewFlowTable,
        app: CBONDS,
        model: "CBonds_NewFlow",
    },
    {
        key: "CBonds_Offer",
        label: "CBonds_Offer",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCBondsOfferTable,
        app: CBONDS,
        model: "CBonds_Offer",
    },
    {
        key: "CBonds_Tradings",
        label: "CBonds_Tradings",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCBondsTradingsTable,
        app: CBONDS,
        model: "CBonds_Tradings",
    },
    {
        key: "DL_AliasNomesDevedores",
        label: "DL_AliasNomesDevedores",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterAliasNomeDevedorTable,
        app: DATALAKE,
        model: "AliasNomesDevedores",
    },
    {
        key: "DL_AmortDeprecCVM",
        label: "DL_AmortDeprecCVM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterAmortDeprecCVMTable,
        app: DATALAKE,
        model: "AmortDeprecCVM",
    },
    {
        key: "DL_AmortDeprecDFCAuxCVM",
        label: "DL_AmortDeprecDFCAuxCVM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterAmortDeprecDFCAuxCVMTable,
        app: DATALAKE,
        model: "AmortDeprecDFCAuxCVM",
    },
    {
        key: "DL_AmortDeprecDREAuxCVM",
        label: "DL_AmortDeprecDREAuxCVM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterAmortDeprecDREAuxCVMTable,
        app: DATALAKE,
        model: "AmortDeprecDREAuxCVM",
    },
    {
        key: "DL_ANBIMANegociosTPF",
        label: "DL_ANBIMANegociosTPF",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterDatalakeANBIMANegociosTPFTable,
        app: DATALAKE,
        model: "ANBIMANegociosTPF",
    },
    {
        key: "DL_ANBIMAPrecos",
        label: "DL_ANBIMAPrecos",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterANBIMAPrecosTable,
        app: DATALAKE,
        model: "ANBIMAPrecos",
    },
    {
        key: "DL_ANBIMAPrecosTPF",
        label: "DL_ANBIMAPrecosTPF",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterDatalakeANBIMAPrecosTPFTable,
        app: DATALAKE,
        model: "ANBIMAPrecosTPF",
    },
    {
        key: "DL_AtualizacaoIndices",
        label: "DL_AtualizacaoIndices",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterDatalakeAtualizacaoIndicesTable,
        app: DATALAKE,
        model: "AtualizacaoIndices",
    },
    {
        key: "DL_B3AtivosReg",
        label: "DL_B3AtivosReg",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterB3AtivosRegTable,
        app: DATALAKE,
        model: "B3AtivosReg",
    },
    {
        key: "DL_B3FundosNET",
        label: "DL_B3FundosNET",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterDatalakeB3FundosNETTable,
        app: DATALAKE,
        model: "B3FundosNET",
    },
    {
        key: "DL_B3ISINEmissor",
        label: "DL_B3ISINEmissor",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterDatalakeB3ISINEmissorTable,
        app: DATALAKE,
        model: "B3ISINEmissor",
    },
    {
        key: "DL_B3ISINRelacao",
        label: "DL_B3ISINRelacao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterDatalakeB3ISINRelacaoTable,
        app: DATALAKE,
        model: "B3ISINRelacao",
    },
    {
        key: "DL_B3NegAnalitico",
        label: "DL_B3NegAnalitico",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterB3NegAnaliticoTable,
        app: DATALAKE,
        model: "B3NegAnalitico",
    },
    {
        key: "DL_B3NegConsolidado",
        label: "DL_B3NegConsolidado",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterB3NegConsolidadoTable,
        app: DATALAKE,
        model: "B3NegConsolidado",
    },
    {
        key: "DL_B3Setores",
        label: "DL_B3Setores",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterB3SetoresTable,
        app: DATALAKE,
        model: "B3Setores",
    },
    {
        key: "DL_B3TickerCNPJ",
        label: "DL_B3TickerCNPJ",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterB3TickerCNPJTable,
        app: DATALAKE,
        model: "B3TickerCNPJ",
    },
    {
        key: "DL_BACENCadastroConglomerado",
        label: "DL_BACENCadastroConglomerado",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterDatalakeBACENCadastroConglomeradoTable,
        app: DATALAKE,
        model: "BACENCadastroConglomerado",
    },
    {
        key: "DL_BACENCadastroEmpresa",
        label: "DL_BACENCadastroEmpresa",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterDatalakeBACENCadastroEmpresaTable,
        app: DATALAKE,
        model: "BACENCadastroEmpresa",
    },
    {
        key: "DL_BACENSegmentacao",
        label: "DL_BACENSegmentacao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterDatalakeBACENSegmentacaoTable,
        app: DATALAKE,
        model: "BACENSegmentacao",
    },
    {
        key: "DL_BroadcastCotacoesAcoesB3",
        label: "DL_BroadcastCotacoesAcoesB3",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterBroadcastCotacoesAcoesB3Table,
        app: DATALAKE,
        model: "BroadcastCotacoesAcoesB3",
    },
    {
        key: "DL_CalendarioInflacao",
        label: "DL_CalendarioInflacao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCalendarioInflacaoTable,
        app: DATALAKE,
        model: "CalendarioInflacao",
    },
    {
        key: "DL_CETIP_Operacoes",
        label: "DL_CETIP_Operacoes",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterDatalakeCETIPOperacoesTable,
        app: DATALAKE,
        model: "CETIPOperacoes",
    },
    {
        key: "DL_CaracteristicasEmissao",
        label: "DL_CaracteristicasEmissao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCaracteristicasEmissaoTable,
        app: DATALAKE,
        model: "CaracteristicasEmissao",
    },
    {
        key: "DL_ChecagemDadosFinanceirosCVM",
        label: "DL_ChecagemDadosFinanceirosCVM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterChecagemDadosFinanceirosCVMTable,
        app: DATALAKE,
        model: "ChecagemDadosFinanceirosCVM",
    },
    {
        key: "DL_Contraparte",
        label: "DL_Contraparte",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterContraparteTable,
        app: DATALAKE,
        model: "Contraparte",
    },
    {
        key: "DL_CurvasSpreadsIndicativos",
        label: "DL_CurvasSpreadsIndicativos",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCurvasSpreadsIndicativosTable,
        app: DATALAKE,
        model: "CurvasSpreadsIndicativos",
    },
    {
        key: "DL_CVMCadastroEmissor",
        label: "DL_CVMCadastroEmissor",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMCadastroEmissorTable,
        app: DATALAKE,
        model: "CVMCadastroEmissor",
    },
    {
        key: "DL_CVMCadastroEmpresas",
        label: "DL_CVMCadastroEmpresas",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMCadastroEmpresasTable,
        app: DATALAKE,
        model: "CVMCadastroEmpresas",
    },
    {
        key: "DL_CVMCadastroSituacao",
        label: "DL_CVMCadastroSituacao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMCadastroSituacaoTable,
        app: DATALAKE,
        model: "CVMCadastroSituacao",
    },
    {
        key: "DL_CVMComposicaoCapital",
        label: "DL_CVMComposicaoCapital",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMComposicaoCapitalTable,
        app: DATALAKE,
        model: "CVMComposicaoCapital",
    },
    {
        key: "DL_CVMDadosFinanceiros",
        label: "DL_CVMDadosFinanceiros",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMDadosFinanceirosTable,
        app: DATALAKE,
        model: "CVMDadosFinanceiros",
    },
    {
        key: "DL_CVMFatosRelevantes",
        label: "DL_CVMFatosRelevantes",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMFatosRelevantesTable,
        app: DATALAKE,
        model: "CVMFatosRelevantes",
    },
    {
        key: "DL_CVMPareceres",
        label: "DL_CVMPareceres",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMPareceresTable,
        app: DATALAKE,
        model: "CVMPareceres",
    },
    {
        key: "DL_CVMBPA",
        label: "DL_CVMBPA",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMBPATable,
        app: DATALAKE,
        model: "CVMBPA",
    },
    {
        key: "DL_CVMBPATRAT",
        label: "DL_CVMBPATRAT",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMBPATRATTable,
        app: DATALAKE,
        model: "CVMBPATRAT",
    },
    {
        key: "DL_CVMBPP",
        label: "DL_CVMBPP",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMBPPTable,
        app: DATALAKE,
        model: "CVMBPP",
    },
    {
        key: "DL_CVMBPPTRAT",
        label: "DL_CVMBPPTRAT",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMBPPTRATTable,
        app: DATALAKE,
        model: "CVMBPPTRAT",
    },
    {
        key: "DL_CVMDFC",
        label: "DL_CVMDFC",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMDFCTable,
        app: DATALAKE,
        model: "CVMDFC",
    },
    {
        key: "DL_CVMDFCTRAT",
        label: "DL_CVMDFCTRAT",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMDFCTRATTable,
        app: DATALAKE,
        model: "CVMDFCTRAT",
    },
    {
        key: "DL_CVMDMPL",
        label: "DL_CVMDMPL",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMDMPLTable,
        app: DATALAKE,
        model: "CVMDMPL",
    },
    {
        key: "DL_CVMDMLPTRAT",
        label: "DL_CVMDMLPTRAT",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMDMPLTRATTable,
        app: DATALAKE,
        model: "CVMDMLPTRAT",
    },
    {
        key: "DL_CVMDRA",
        label: "DL_CVMDRA",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMDRATable,
        app: DATALAKE,
        model: "CVMDRA",
    },
    {
        key: "DL_CVMDRE",
        label: "DL_CVMDRE",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMDRETable,
        app: DATALAKE,
        model: "CVMDRE",
    },
    {
        key: "DL_CVMDRETRAT",
        label: "DL_CVMDRETRAT",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMDRETRATTable,
        app: DATALAKE,
        model: "CVMDRETRAT",
    },
    {
        key: "DL_CVMDVA",
        label: "DL_CVMDVA",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCVMDVATable,
        app: DATALAKE,
        model: "CVMDVA",
    },
    {
        key: "DL_EstruturaDFsEmpresaCVM",
        label: "DL_EstruturaDFsEmpresaCVM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEstruturaDFsEmpresaCVMTable,
        app: DATALAKE,
        model: "EstruturaDFsEmpresaCVM",
    },
    {
        key: "DL_PrecosVariacaoDiaria",
        label: "DL_PrecosVariacaoDiaria",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosVariacaoDiariaTable,
        app: DATALAKE,
        model: "PrecosVariacaoDiaria",
    },
    {
        key: "DL_EventosCreditoDevedor",
        label: "DL_EventosCreditoDevedor",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEventosCreditoDevedorTable,
        app: DATALAKE,
        model: "EventosCreditoDevedor",
    },
    {
        key: "DL_EventosCreditoEmissao",
        label: "DL_EventosCreditoEmissao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEventosCreditoEmissaoTable,
        app: DATALAKE,
        model: "EventosCreditoEmissao",
    },
    {
        key: "DL_FINCS_Eventos",
        label: "DL_FINCS_Eventos",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterFincsEventosTable,
        app: DATALAKE,
        model: "FincsEventos",
    },
    {
        key: "DL_FINCS_Juros",
        label: "DL_FINCS_Juros",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterFincsJurosTable,
        app: DATALAKE,
        model: "FincsJuros",
    },
    {
        key: "DL_FINCS_MarketData",
        label: "DL_FINCS_MarketData",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterFincsMarketDataTable,
        app: DATALAKE,
        model: "FincsMarketData",
    },
    {
        key: "DL_IndiceInflacao",
        label: "DL_IndiceInflacao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterIndiceInflacaoTable,
        app: DATALAKE,
        model: "IndiceInflacao",
    },
    {
        key: "DL_Liquidez",
        label: "DL_Liquidez",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterLiquidezTable,
        app: DATALAKE,
        model: "Liquidez",
    },
    {
        key: "DL_ListaPalavrasEBITDACVM",
        label: "DL_ListaPalavrasEBITDACVM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterListaPalavrasEBITDACVMTable,
        app: DATALAKE,
        model: "ListaPalavrasEBITDACVM",
    },
    {
        key: "DL_ListaPalavrasTributosCVM",
        label: "DL_ListaPalavrasTributosCVM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterListaPalavrasTributosCVMTable,
        app: DATALAKE,
        model: "ListaPalavrasTributosCVM",
    },
    {
        key: "DL_LTVEmissao",
        label: "DL_LTVEmissao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterLTVEmissaoTable,
        app: DATALAKE,
        model: "LTVEmissao",
    },
    {
        key: "DL_MappingContas",
        label: "DL_MappingContas",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterMappingContasCVMTable,
        app: DATALAKE,
        model: "MappingContasCVM",
    },
    {
        key: "DL_PeriodicidadeBalanco",
        label: "DL_PeriodicidadeBalanco",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPeriodicidadeBalancoTable,
        app: DATALAKE,
        model: "PeriodicidadeBalanco",
    },
    {
        key: "DL_PrecosAndados",
        label: "DL_PrecosAndados",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosAndadosTable,
        app: DATALAKE,
        model: "PrecosAndados",
    },
    {
        key: "DL_PrecosEventosFinanceirosPUMTM",
        label: "DL_PrecosEventosFinanceirosPUMTM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosEventosFinanceirosPUMTMTable,
        app: DATALAKE,
        model: "PrecosEventosFinanceirosPUMTM",
    },
    {
        key: "DL_PrecosEventosFinanceirosPUPAR",
        label: "DL_PrecosEventosFinanceirosPUPAR",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosEventosFinanceirosPUPARTable,
        app: DATALAKE,
        model: "PrecosEventosFinanceirosPUPAR",
    },
    {
        key: "DL_PrecosInadimplentesLGD",
        label: "DL_PrecosInadimplentesLGD",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosInadimplentesLGDTable,
        app: DATALAKE,
        model: "PrecosInadimplentesLGD",
    },
    {
        key: "DL_PrecosProcessados",
        label: "DL_PrecosProcessados",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosProcessadosTable,
        app: DATALAKE,
        model: "PrecosProcessados",
    },
    {
        key: "DL_PrecosProcessadosBonds",
        label: "DL_PrecosProcessadosBonds",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosProcessadosBondsTable,
        app: DATALAKE,
        model: "PrecosProcessadosBonds",
    },
    {
        key: "DL_PrecosSpreadsIndicativos",
        label: "DL_PrecosSpreadsIndicativos",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosSpreadsIndicativosTable,
        app: DATALAKE,
        model: "PrecosSpreadsIndicativos",
    },
    {
        key: "DL_PrecosSpreadsRelativos",
        label: "DL_PrecosSpreadsRelativos",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosSpreadsRelativosTable,
        app: DATALAKE,
        model: "PrecosSpreadsRelativos",
    },
    {
        key: "DL_PrecosTunel",
        label: "DL_PrecosTunel",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosTunelTable,
        app: DATALAKE,
        model: "PrecosTunel",
    },
    {
        key: "DL_PrecosValidacaoPUPAR",
        label: "DL_PrecosValidacaoPUPAR",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosValidacaoPUPARTable,
        app: DATALAKE,
        model: "PrecosValidacaoPUPAR",
    },
    {
        key: "DL_PreviaInflacao",
        label: "DL_PreviaInflacao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPreviaInflacaoTable,
        app: DATALAKE,
        model: "PreviaInflacao",
    },
    {
        key: "DL_RatingDevedor",
        label: "DL_RatingDevedor",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRatingDevedorTable,
        app: DATALAKE,
        model: "RatingDevedor",
    },
    {
        key: "DL_RatingEmissao",
        label: "DL_RatingEmissao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRatingEmissaoTable,
        app: DATALAKE,
        model: "RatingEmissao",
    },
    {
        key: "DL_RelatorioInconsistenciaDadosFinanceirosCVM",
        label: "DL_RelatorioInconsistenciaDadosFinanceirosCVM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRelatorioInconsistenciaDadosFinanceirosCVMTable,
        app: DATALAKE,
        model: "RelatorioInconsistenciaDadosFinanceirosCVM",
    },
    {
        key: "DL_RiskFree",
        label: "DL_RiskFree",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRiskFreeTable,
        app: DATALAKE,
        model: "RiskFree",
    },
    {
        key: "DL_SecuritizacoesInformeMensal",
        label: "DL_SecuritizacoesInformeMensal",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterDatalakeSecuritizacoesInformeMensalTable,
        app: DATALAKE,
        model: "SecuritizacoesInformeMensal",
    },
    {
        key: "DL_SelecaoContasEBITDACVM",
        label: "DL_SelecaoContasEBITDACVM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterSelecaoContasEBITDACVMTable,
        app: DATALAKE,
        model: "SelecaoContasEBITDACVM",
    },
    {
        key: "DL_SelecaoContasTributosCVM",
        label: "DL_SelecaoContasTributosCVM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterSelecaoContasTributosCVMTable,
        app: DATALAKE,
        model: "SelecaoContasTributosCVM",
    },
    {
        key: "DL_SetorialPerspectiva",
        label: "DL_SetorialPerspectiva",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterSetorialPerspectivaTable,
        app: DATALAKE,
        model: "SetorialPerspectiva",
    },
    {
        key: "DL_SpreadsDevedor",
        label: "DL_SpreadsDevedor",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterSpreadsDevedorTable,
        app: DATALAKE,
        model: "SpreadsDevedor",
    },
    {
        key: "DL_SpreadsEmissao",
        label: "DL_SpreadsEmissao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterSpreadsEmissaoTable,
        app: DATALAKE,
        model: "SpreadsEmissao",
    },
    {
        key: "DL_SpreadsIFNeg",
        label: "DL_SpreadsIFNeg",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterSpreadsIfNegTable,
        app: DATALAKE,
        model: "SpreadsIFNeg",
    },
    {
        key: "DL_SpreadsIndicativosBruto",
        label: "DL_SpreadsIndicativosBruto",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterSpreadsIndicativosBrutoTable,
        app: DATALAKE,
        model: "SpreadsIndicativosBruto",
    },
    {
        key: "DL_SpreadsLiquidez",
        label: "DL_SpreadsLiquidez",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterSpreadsLiquidezTable,
        app: DATALAKE,
        model: "SpreadsLiquidez",
    },
    {
        key: "DL_SpreadsNegociados",
        label: "DL_SpreadsNegociados",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterSpreadsNegociadosTable,
        app: DATALAKE,
        model: "SpreadsNegociados",
    },
    {
        key: "DL_SpreadsNegociadosConsolidados",
        label: "DL_SpreadsNegociadosConsolidados",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterSpreadsNegociadosTable,
        app: DATALAKE,
        model: "SpreadsNegociadosConsolidados",
    },
    {
        key: "DL_SpreadsSecPulverizado",
        label: "DL_SpreadsSecPulverizado",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterSpreadsSecPulverizadoTable,
        app: DATALAKE,
        model: "SpreadsSecPulverizado",
    },
    {
        key: "DL_TaxasJuros",
        label: "DL_TaxasJuros",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterTaxaJurosTable,
        app: DATALAKE,
        model: "TaxasJuros",
    },
    {
        key: "DL_TaxasTR",
        label: "DL_TaxasTR",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterTaxasTrTable,
        app: DATALAKE,
        model: "TaxasTR",
    },
    {
        key: "DL_TipoEstruturasDFsCVM",
        label: "DL_TipoEstruturasDFsCVM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterTipoEstruturasDFsCVMTable,
        app: DATALAKE,
        model: "TipoEstruturasDFsCVM",
    },
    {
        key: "DL_TributosCVM",
        label: "DL_TributosCVM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterTributosCVMTable,
        app: DATALAKE,
        model: "TributosCVM",
    },
    {
        key: "DL_B3AcoesNegAnalitico",
        label: "DL_B3AcoesNegAnalitico",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterDatalakeB3AcoesNegAnaliticoTable,
        app: DATALAKE,
        model: "B3AcoesNegAnalitico",
    },
    {
        key: "DL_B3AcoesRegistrado",
        label: "DL_B3AcoesRegistrado",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterDatalakeB3AcoesRegistradoTable,
        app: DATALAKE,
        model: "B3AcoesRegistrado",
    },
    {
        key: "MC_ControleLogEmissaoRendaFixa",
        label: "MC_ControleLogEmissaoRendaFixa",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterControleLogEmissaoRendaFixaTable,
        app: MOTOR,
        model: "ControleLogEmissaoRendaFixa",
    },
    {
        key: "MC_EmissaoRendaFixaCadastroControle",
        label: "MC_EmissaoRendaFixaCadastroControle",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaCadastroControleTable,
        app: MOTOR,
        model: "EmissaoRendaFixaCadastroControle",
    },
    {
        key: "MC_EmissaoRendaFixaEventosOrdinarios",
        label: "MC_EmissaoRendaFixaEventosOrdinarios",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaEventosOrdinariosTable,
        app: MOTOR,
        model: "EmissaoRendaFixaEventosOrdinarios",
    },
    {
        key: "MC_EmissaoRendaFixaParametros",
        label: "MC_EmissaoRendaFixaParametros",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaParametrosTable,
        app: MOTOR,
        model: "EmissaoRendaFixaParametros",
    },
    {
        key: "MC_EmissaoRendaFixaCaracteristicas",
        label: "MC_EmissaoRendaFixaCaracteristicas",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaCaracteristicasTable,
        app: MOTOR,
        model: "EmissaoRendaFixaCaracteristicas",
    },
    {
        key: "MC_EmissaoRendaFixaCovenants",
        label: "MC_EmissaoRendaFixaCovenants",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaCovenantsTable,
        app: MOTOR,
        model: "EmissaoRendaFixaCovenants",
    },
    {
        key: "MC_EmissaoRendaFixaGarantias",
        label: "MC_EmissaoRendaFixaGarantias",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaGarantiasTable,
        app: MOTOR,
        model: "EmissaoRendaFixaGarantias",
    },
    {
        key: "MC_EmissaoRendaFixaLTV",
        label: "MC_EmissaoRendaFixaLTV",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaLTVTable,
        app: MOTOR,
        model: "EmissaoRendaFixaLTV",
    },
    {
        key: "MC_EmissaoRendaFixaOferta",
        label: "MC_EmissaoRendaFixaOferta",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaOfertaTable,
        app: MOTOR,
        model: "EmissaoRendaFixaOferta",
    },
    {
        key: "MC_EmissaoRendaFixaDataAniversario",
        label: "MC_EmissaoRendaFixaDataAniversario",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaDataAniversarioTable,
        app: MOTOR,
        model: "EmissaoRendaFixaDataAniversario",
    },
    {
        key: "MC_EmissaoRendaFixaEventosExtraordinarios",
        label: "MC_EmissaoRendaFixaEventosExtraordinarios",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaEventosExtraordinariosTable,
        app: MOTOR,
        model: "EmissaoRendaFixaEventosExtraordinarios",
    },
    {
        key: "MC_EmissaoRendaFixaPremio",
        label: "MC_EmissaoRendaFixaPremio",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaPremioTable,
        app: MOTOR,
        model: "EmissaoRendaFixaPremio",
    },
    {
        key: "MC_EmissaoRendaFixaEventosConciliacao",
        label: "MC_EmissaoRendaFixaEventosConciliacao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaEventosConciliacaoTable,
        app: MOTOR,
        model: "EmissaoRendaFixaEventosConciliacao",
    },
    {
        key: "MC_EmissaoRendaFixaRecompraProgramada",
        label: "MC_EmissaoRendaFixaRecompraProgramada",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaRecompraProgramadaTable,
        app: MOTOR,
        model: "EmissaoRendaFixaRecompraProgramada",
    },
    {
        key: "MC_EmissaoRendaFixaConversibilidade",
        label: "MC_EmissaoRendaFixaConversibilidade",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterEmissaoRendaFixaConversibilidadeTable,
        app: MOTOR,
        model: "EmissaoRendaFixaConversibilidade",
    },
    {
        key: "MC_FormulaPremio",
        label: "MC_FormulaPremio",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterFormulaPremioTable,
        app: MOTOR,
        model: "FormulaPremio",
    },
    {
        key: "MC_Juros",
        label: "MC_Juros",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterJurosTable,
        app: MOTOR,
        model: "Juros",
    },
    {
        key: "MC_PrecosCalculadosConversibilidade",
        label: "MC_PrecosCalculadosConversibilidade",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosCalculadosConversibilidadeTable,
        app: MOTOR,
        model: "PrecosCalculadosConversibilidade",
    },
    {
        key: "MC_PrecosValidacaoDiario",
        label: "MC_PrecosValidacaoDiario",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosValidacaoDiarioTable,
        app: MOTOR,
        model: "PrecosValidacaoDiario",
    },
    {
        key: "MC_PrecosEventosFinanceiros",
        label: "MC_PrecosEventosFinanceiros",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosEventosFinanceirosTable,
        app: MOTOR,
        model: "PrecosEventosFinanceiros",
    },
    {
        key: "MC_PrecosCalculados",
        label: "MC_PrecosCalculados",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosCalculadosTable,
        app: MOTOR,
        model: "PrecosCalculados",
    },
        {
        key: "MC_PrecosCalculadosAbertura",
        label: "MC_PrecosCalculadosAbertura",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterPrecosCalculadosAberturaTable,
        app: MOTOR,
        model: "PrecosCalculadosAbertura",
    },
    {
        key: "MC_MemoriaCalculoPUPAR",
        label: "MC_MemoriaCalculoPUPAR",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterMemoriaCalculoPUPARTable,
        app: MOTOR,
        model: "MemoriaCalculoPUPAR",
    },
    {
        key: "MC_MemoriaCalculoPUMTM",
        label: "MC_MemoriaCalculoPUMTM",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterMemoriaCalculoPUMTMTable,
        app: MOTOR,
        model: "MemoriaCalculoPUMTM",
    },
    {
        key: "MC_MemoriaCalculoFatorCorrecao",
        label: "MC_MemoriaCalculoFatorCorrecao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterMemoriaCalculoFatorCorrecaoTable,
        app: MOTOR,
        model: "MemoriaCalculoFatorCorrecao",
    },

    {
        key: "MC_MemoriaCalculoPUAbertura",
        label: "MC_MemoriaCalculoPUAbertura",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterMemoriaCalculoPUAberturaTable,
        app: MOTOR,
        model: "MemoriaCalculoPUAbertura",
    },
    {
        key: "RT_MMCotacoes",
        label: "RT_MMCotacoes",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRaterMMCotacoesTable,
        app: RATER,
        model: "MMCotacoes",
    },
    {
        key: "RT_MMCotacoesAcoesB3Ajustado",
        label: "RT_MMCotacoesAcoesB3Ajustado",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRaterMMCotacoesAcoesB3AjustadoTable,
        app: RATER,
        model: "MMCotacoesAcoesB3Ajustado",
    },
    {
        key: "RT_MMPD",
        label: "RT_MMPD",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRaterMMPDTable,
        app: RATER,
        model: "MMPD",
    },
    {
        key: "RT_MMResultadoEmpresa",
        label: "RT_MMResultadoEmpresa",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRaterMMResultadoEmpresaTable,
        app: RATER,
        model: "MMResultadoEmpresa",
    },
    {
        key: "RT_MMResultadoRating",
        label: "RT_MMResultadoRating",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRaterMMResultadoRatingTable,
        app: RATER,
        model: "MMResultadoRating",
    },
    {
        key: "RT_MMTickerCNPJ",
        label: "RT_MMTickerCNPJ",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRaterMMTickerCNPJTable,
        app: RATER,
        model: "MMTickerCNPJ",
    },
    {
        key: "RT_MMVolatilidadeTicker",
        label: "RT_MMVolatilidadeTicker",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRaterMMVolatilidadeTickerTable,
        app: RATER,
        model: "MMVolatilidadeTicker",
    },
    {
        key: "RT_UserCadastroEmpresas",
        label: "RT_UserCadastroEmpresas",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRaterUserCadastroEmpresasTable,
        app: RATER,
        model: "UserCadastroEmpresa",
    },
    {
        key: "RT_UserSetorial",
        label: "RT_UserSetorial",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRaterUserSetorialTable,
        app: RATER,
        model: "UserSetorial",
    }
]